/**
 * Module for events used in core
 * @module
 */

var EventEmitter = require('core/event_emitter');

/**
 * Emit an event when an error is thrown (and caught)
 * @param {Error} error
 * @param {Object} [errorMetadata]
 * @param {boolean} [isInternal]
 */
exports.emitError = function(error:Error, errorMetadata?:any, isInternal?:boolean) {
  var suppressErrors = true;

  EventEmitter.emit({
    type: 'error',
    name: error.name || 'Error',
    data: {
      error: error,
      metadata: errorMetadata,
    },
  }, isInternal || false, suppressErrors);
};

/**
 * Emit an error with the isInternal flag set to true. Use for events which shouldn't
 * bubble out of the client.
 *
 * @param {Error} error
 * @param {Object} [errorMetadata]
 */
exports.emitInternalError = function(error:Error, errorMetadata?:any) {
  exports.emitError(error, errorMetadata, true);
};

/**
 * @typedef {Object} MetricsValues
 * @property {number} revenue
 */

/**
 * @param {Object} config
 * @param {string} config.type
 * @param {string} config.name
 * @param {string} config.apiName
 * @param {string} config.category
 * @param {module:api_events/index~MetricsValues} [config.metrics]
 * @param {Object} config.tags
 * @param {boolean} internalOnly
 */
exports.emitAnalyticsEvent = function(config:any, internalOnly:boolean) {
  var analyticsEvent = {
    type: 'analytics',
    name: 'trackEvent',
    data: config,
  };

  if (__INVARIANT__) {
    require('core/utils/invariant').isType('AnalyticsApiEvent', analyticsEvent);
  }

  EventEmitter.emit(analyticsEvent, internalOnly);
};
